import { render, staticRenderFns } from "./hotActive.vue?vue&type=template&id=123a79d8&scoped=true&"
import script from "./hotActive.vue?vue&type=script&lang=js&"
export * from "./hotActive.vue?vue&type=script&lang=js&"
import style0 from "./hotActive.vue?vue&type=style&index=0&id=123a79d8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123a79d8",
  null
  
)

export default component.exports